// B-108 — the pending notes' filters: kind, status, office and age, each a native select so it works
// from the keyboard and on a phone. A screen shows only the ones that make sense there (an office's
// own list has no office filter; the day's open notes have no status filter), and the options are
// only what the notes carry (`opcionesDePendientes`). "Limpiar" appears once one is set.
import { ESTADOS_PENDIENTE, ANTIGUEDADES, hayFiltros, tipoDePendiente } from "../../../utils/cierreCuadreDia";

const SELECT = "h-8 min-w-0 rounded-[6px] border bg-card px-2 text-[12px] text-brinks-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export function FiltrosPendientes({
  filtros, onChange, opciones, campos = ["tipo", "estado", "oficina", "antiguedad"],
}) {
  const poner = (clave) => (e) => onChange({ ...filtros, [clave]: e.target.value });
  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filtros de pendientes">
      {campos.includes("tipo") ? (
        <select aria-label="Tipo de pendiente" className={SELECT} value={filtros.tipo || ""} onChange={poner("tipo")}>
          <option value="">Todos los tipos</option>
          {(opciones.tipos || []).map((tipo) => <option key={tipo} value={tipo}>{tipoDePendiente(tipo)}</option>)}
        </select>
      ) : null}
      {campos.includes("estado") ? (
        <select aria-label="Estado del pendiente" className={SELECT} value={filtros.estado || ""} onChange={poner("estado")}>
          <option value="">Todos los estados</option>
          {Object.entries(ESTADOS_PENDIENTE).map(([estado, texto]) => <option key={estado} value={estado}>{texto}</option>)}
        </select>
      ) : null}
      {campos.includes("oficina") ? (
        <select aria-label="Oficina del pendiente" className={SELECT} value={filtros.oficina || ""} onChange={poner("oficina")}>
          <option value="">Todas las oficinas</option>
          {(opciones.oficinas || []).map((o) => (
            <option key={o.codigo} value={o.codigo}>{o.nombre ? `${o.codigo} ${o.nombre}` : o.codigo}</option>
          ))}
        </select>
      ) : null}
      {campos.includes("antiguedad") ? (
        <select aria-label="Antigüedad del pendiente" className={SELECT} value={filtros.antiguedad || ""} onChange={poner("antiguedad")}>
          {ANTIGUEDADES.map((a) => <option key={a.key} value={a.key}>{a.label}</option>)}
        </select>
      ) : null}
      {hayFiltros(filtros) ? (
        <button
          type="button"
          className="h-8 rounded-[6px] px-2 text-[12px] text-brinks-muted-foreground underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          onClick={() => onChange({})}
        >
          Limpiar
        </button>
      ) : null}
    </div>
  );
}

export default FiltrosPendientes;
